export const services = [
  {
    title: 'Interior Painting',
    items: ['Walls & ceilings', 'Trim, doors & baseboards', 'Accent walls', 'Cabinets']
  },
  {
    title: 'Exterior Painting',
    items: ['Siding & stucco', 'Fascia & soffits', 'Doors & shutters', 'Fences & sheds']
  },
  {
    title: 'Prep & Repair',
    items: ['Pressure washing', 'Drywall patching', 'Caulking & sealing', 'Sanding & priming']
  },
  {
    title: 'Commercial',
    items: ['Offices & retail', 'Rentals & turnovers', 'Apartments', 'After-hours work']
  }
]
